
 
// BlogPost.jsx
import { useParams } from "react-router-dom";
import { blogPosts } from "../Blog/data/blogPost";
import ReactMarkdown from "react-markdown";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

function BlogPost() {
  const { id } = useParams();
  const post = blogPosts.find((p) => p.id === id);

  if (!post) {
    return <p className="text-center mt-10 text-red-500">Post not found.</p>;
  }

  return (
    <div className="bg-white text-[#1A3C34] font-sans">
      <Navbar />

      <main className="max-w-3xl mx-auto px-6 py-20">
        <h1 className="text-4xl md:text-5xl font-bold italic mb-4">{post.title}</h1>
        <p className="text-sm text-gray-600 mb-6">{post.date}</p>
        <div className="prose prose-lg text-[#1A3C34] max-w-none">
          <ReactMarkdown>{post.content}</ReactMarkdown>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default BlogPost;
